import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { path, sessionVar } from "../../utils/common/constant";
import { useNavigate } from "react-router-dom";
import { Button, Menu, Popconfirm, Switch, Popover, Tooltip } from "antd";
import imgadmin from "../../assets/common/logo_rb.png";
import { getSessionVar } from "../../utils/common/hashData";
const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  const [theme, setTheme] = useState("dark");

  const changeTheme = (value) => {
    setTheme(value ? "dark" : "light");
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCollapsed(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const items = [
    {
      key: "blogs",
      label: (
        <div
          className=""
          onClick={() => {
            navigate("../" + path.private.MANAGEBLOG);
          }}
        >
          <p className=" text-lg">Blogs</p>
        </div>
      ),
      icon: (
        <Icon
          icon="mdi:events-check"
          className="h-5 w-5"
          onClick={() => {
            navigate("../" + path.private.MANAGEBLOG);
          }}
        ></Icon>
      ),
      children: "",
      type: "",
    },
    {
      key: "projects",
      label: (
        <div
          className=""
          onClick={() => {
            navigate("../" + path.private.MANAGEPROJECTS);
          }}
        >
          <p className=" text-lg">Projects</p>
        </div>
      ),
      icon: (
        <Icon
          icon="eos-icons:project-outlined"
          className="h-5 w-5"
          onClick={() => {
            navigate("../" + path.private.MANAGEPROJECTS);
          }}
        ></Icon>
      ),
      children: "",
      type: "",
    },
  ];
  const confirm = (e) => {
    navigate("../" + path.common.ADMIN);
    sessionStorage.clear();
  };
  const cancel = (e) => {};

  const user = getSessionVar(sessionVar.user);

  const navigate = useNavigate();

  return (
    <>
      <div
        className={
          theme === "dark"
            ? `bg-[#001529] ${
                collapsed ? "" : "w-[300px]"
              }   py-2  flex flex-col justify-between `
            : `bg-white  py-2  flex flex-col justify-between ${
                collapsed ? "" : "w-[300px]"
              } `
        }
      >
        <div className="">
          <Button
            type="primary"
            className={
              theme === "dark"
                ? "w-[72px] h-[40px] mx-1  bg-transparent hover:bg-[#1677ff] flex justify-center items-center text-white hover:text-black pv:max-md:hidden"
                : "w-[72px] h-[40px] mx-1  bg-transparent hover:bg-[#1677ff] flex justify-center items-center text-black hover:text-white pv:max-md:hidden"
            }
            onClick={toggleCollapsed}
            style={{
              marginBottom: 16,
            }}
          >
            {collapsed ? (
              <Icon icon={"line-md:menu-fold-right"} className="w-6 h-6" />
            ) : (
              <Icon icon={"line-md:menu-fold-left"} className="w-6 h-6" />
            )}
          </Button>

          <Menu
            defaultSelectedKeys={["1"]}
            defaultOpenKeys={["1"]}
            mode="inline"
            theme={theme}
            inlineCollapsed={collapsed}
            items={items}
            className=""
          />
        </div>

        <div className={`w-[300px] ${collapsed ? "hidden" : "block"}`}>
          <button className="w-full flex  items-center p-2 gap-4 ">
            <img
              className="h-12 w-12 rounded-full object-cover shadow-sm "
              src={imgadmin}
              alt="Content"
            ></img>
            <p className="text-white">{user.name}</p>
          </button>

          <div className={` flex items-center p-2 gap-4`}>
            <Popconfirm
              placement="topRight"
              title="Log out"
              description="Are you sure log out ?"
              onConfirm={confirm}
              onCancel={cancel}
              okText="Confirm"
              cancelText="Cancel"
            >
              <Button
                type="primary"
                className={
                  theme === "dark"
                    ? " mx-1  bg-transparent hover:bg-[#1677ff] flex justify-center items-center text-white hover:text-black"
                    : "mx-1  bg-transparent hover:bg-[#1677ff] flex justify-center items-center text-black hover:text-white"
                }
              >
                <Icon
                  icon={"material-symbols:logout"}
                  className="w-6 h-6"
                ></Icon>
                Logout
              </Button>
            </Popconfirm>
            <Switch
              checked={theme === "dark"}
              onChange={changeTheme}
              checkedChildren="Dark"
              unCheckedChildren="Light"
              className="bg-gray-600"
            />
          </div>
        </div>

        <div
          className={` w-[80px] flex items-center flex-col gap-4  ${
            collapsed ? "flex" : "hidden"
          } `}
        >
          <div className={`flex items-center gap-1`}>
            <Tooltip title={<p className="text-white">{user.name}</p>}>
              <button>
                <img
                  className="h-14 w-14 rounded-full object-cover shadow-sm "
                  src={imgadmin}
                  alt="Content"
                ></img>
              </button>
            </Tooltip>
          </div>
          <div
            className={` ${
              collapsed
                ? " flex items-center flex-col gap-4 "
                : "flex items-center gap-4"
            }`}
          >
            <Popconfirm
              placement="bottomRight"
              title="Log out"
              description="Are you sure log out ?"
              onConfirm={confirm}
              onCancel={cancel}
              okText="Log out"
              cancelText="No"
            >
              <Button
                type="primary"
                className={
                  theme === "dark"
                    ? " mx-1  bg-transparent hover:bg-[#1677ff] flex justify-center items-center text-white hover:text-black"
                    : "mx-1  bg-transparent hover:bg-[#1677ff] flex justify-center items-center text-black hover:text-white"
                }
              >
                <Icon
                  icon={"material-symbols:logout"}
                  className="w-6 h-6"
                ></Icon>
              </Button>
            </Popconfirm>

            <Switch
              checked={theme === "dark"}
              onChange={changeTheme}
              checkedChildren="Dark"
              unCheckedChildren="Light"
              className="bg-gray-600"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
